/**
 * docs:
 * https://zh.nuxtjs.org/guide/vuex-store
 * https://vuex.vuejs.org/zh/
 */
import cookie from 'js-cookie'
import cookieKeys from '@/const/cookie-keys'
// import throttle from 'lodash/throttle'
import { getUpdateToken, getUserDetail, login, logout } from '@/api/login'
import { getRamNotReviewedNumberApplications } from '~/api/memberCenter/ram'

import { getAuditingNum } from '~/api/memberCenter/exhibition'
import { getSupplyInfoList } from '~/api/supply'

// import { sleep } from '~/utils/util'
// 在严格模式下,无论何时发生了状态变更且不是由 mutation 函数引起的,将会抛出错误。这能保证所有的状态变更都能被调试工具跟踪到。
export const strict = process.env.NODE_ENV !== 'production'
const cookiePath = process.env.COOKIE_PATH

const isObject = (value) => Object.prototype.toString.call(value) === '[object Object]'
// 部署的时候才有值

/**
 * TODO 待优化
 * store无法获取process.env中的值
 * 如果有yzdli.com,说明是正式服
 * 使用 . 前缀让 cookie 可在子域名间共享（如 beta.yunhzh.com 和 beta-supply.yunhzh.com）
 */
let domain = '.yzdli.com'
if (process.client) {
  if (window.location.hostname.includes('yunhzh')) {
    domain = '.yunhzh.com'
  } else if (window.location.hostname.includes('localhost')) {
    domain = 'localhost' // localhost 不能带 . 前缀
  }
}

const getDefaultState = () => {
  return {
    // 登录token
    token: '',
    // 刷新的token
    refreshToken: '',
    // 会员信息
    userInfo: {
      accountLevel: 0,
      username: '',
      loginName: null,
      phone: '',
      email: null,
      memunicode: '',
      inviteCode: '',
      companyFlag: 0,
      company: {
        comunicode: '',
        companyName: '',
        logo: '',
        createTime: '',
        pshExhibitionUp: 0,
        pshExhibitionDown: 0,
        pshMeetingUp: 0,
        pshMeetingDown: 0,
      },
      wxOpenid: '',
      memberCard: {
        contact: '',
        phonearea: '+86',
        phone: '',
        email: '',
        post: '',
        wechat: '',
        cardAvatar: '',
        cardCompanyName: '',
        completion: 0,
        styleId: '0',
      },
      memberAccount: {
        coinSum: '0.00',
        coinValidSum: '0.00',
        coinValid: '0.00',
        coinIncome: '0.00',
        coinInviteAward: '0.00',
        coinIncomeBlock: '0.00',
        couponNum: null,
      },
      roleId: 0, // 1参观商 2主办方 3参展商 4展厅工程商 5设计师
      avatar: '',
      createTime: '',
      auditRoleId: 0, // 大于0说明在审核中, 且对应值是在审核id
      auditStatus: 0,
      auditRemark: null,
      huanxinId: '',
      hadRename: 0,
      chatFlag: 0,
      vipStatus: 0,
      memberVipEndTime: '',
      roomId: '',
      industryId: '',
      companyIndustry: '',
      companyIndustryName: '',
      interestedIndustryName: [''],
      memberSetMealInfo: {
        setMealCode: 0,
        itemCodeList: [101, 301, 401, 501, 601, 702, 703, 801, 901, 1101, 402, 403, 1301, 1401, 1402, 1403, 1404, 1405],
        isBase: 1, // 1为基础版
        expiredTme: null,
      },
      yesterdayNumLook: 1,
      primaryMemberCode: '',
      firstTimeLogin: 1,
      selectedAvatarUrl: '',
      supplyName: '',
      supplyNum: 0,
      isAuthentication: 0,
      blessingNum: null,
    },
    getUserInfoTimer: undefined,
    // 浏览器版本信息
    browser: {},
    // 浏览器版本Base64
    browserBase64: '',
    // 面包屑导航最后新增的导航名称
    breadcrumbLastName: '',
    // 主菜单栏显示隐藏
    mainMenuShow: false,
    // 弹出型注册登录框
    popupLoginStatus: false,
    /**
     * 用户弹框
     * certApplication 认证申请
     * applying 申请中
     *
     * 3.1 改版, 两种情况都弹出提升权益弹窗, 理论上没有申请中, 仅作兼容用
     * */
    certModalType: false,
    // 是否显示完善系统框
    isShowCompeteSystem: false,
    // 交换云展时, 是否显示主账号的信息
    isShowMaster: false,
    // 显示红点的key
    showBadgeDotKeys: [],

    // 展览待审核数量
    auditingNum: 0,

    // ===
    host: undefined,
    locale: 'zh',
    // 所在供应链unicode
    supplyUnicode: undefined,
    // 所在供应链信息
    supplyChainInfo: {
      id: null,
      unicode: null,
      // 自定义行业分类
      categoryOption: [],

      title: null,
      logo: null,
      /**
       * {
       *    id
       *    title
       *    // 图片url
       *    fileUrl
       *    // 跳转链接
       *    redirectUrl
       * }[]
       * */
      banners: [],
    },
  }
}

export const state = getDefaultState

export const mutations = {
  updateSupplyChainInfo(state, data) {
    console.log('updateSupplyChainInfo', data)
    state.supplyChainInfo = data
  },
  updateLocale(state, locale) {
    state.locale = locale
  },
  updateSupplyUnicode(state, unicode) {
    state.supplyUnicode = unicode
  },
  updateHost(state, host) {
    state.host = host
  },
  // 重置所有值
  RESET_ALL(state) {
    // console.log('重置store/init')
    const initState = getDefaultState()
    Object.keys(initState).forEach((key) => {
      state[key] = initState[key]
    })
  },
  SWITCH_SHOW_CART(state, visibleType) {
    // console.log('SWITCH_SHOW_CART', visibleType)
    state.certModalType = visibleType
  },
  SWITCH_IS_SHOW_COMPETE_SYSTEM(state, status) {
    state.isShowCompeteSystem = status
  },

  SWITCH_SHOW_MASTERMODAL(state, isShowMaster) {
    state.isShowMaster = isShowMaster
  },

  setMainMenuShow(state, visible) {
    state.mainMenuShow = visible
  },
  /**
   * @description:
   * @param {*} state {login|register|findPwd|wechatLogin|verifiCodeLogin}
   * @return {*}
   */
  switchPopupLoginStatus(state, visible) {
    state.popupLoginStatus = visible
  },
  testRoleId(state, id) {
    state.roleId = id
  },
  // 浏览器信息
  setBrowser(state, browser) {
    // console.log('setBrowser', browser)
    state.browser = browser
  },
  // 存储浏览器版本Base64
  setBrowserBase64(state, browserBase64) {
    // console.log('setBrowserBase64', browserBase64)
    state.browserBase64 = browserBase64
  },
  // 登录认证token
  SET_TOKEN: (state, token) => {
    // console.log('SET_TOKEN', token)
    state.token = token
  },
  setRegionOption(state, data) {
    state.regionOption = data
  },
  // 添加面包屑导航名称
  setBreadcrumbLastName(state, name) {
    state.breadcrumbLastName = name
  },
  // 更新用户名
  updateUsername(state, username) {
    state.userInfo.username = username
  },
  // 更新头像
  updateAvatar(state, avatarUrl) {
    state.userInfo.avatar = avatarUrl
  },
  // 更新邮箱
  updateEmail(state, email) {
    state.userInfo.email = email
  },
  SET_LOGIN_COOKIE(state, payload) {
    console.log('SET_LOGIN_COOKIE', payload, cookieKeys)
    cookieKeys.forEach((key) => {
      console.log('login', key, payload, payload[key])
      if (payload[key]) {
        state[key] = payload[key]
      }
      console.log('登录cookie设置', domain, cookiePath, payload[key])
      cookie.set(key, payload[key], {
        path: cookiePath || '/', // 建议给个默认值防止 undefined
        domain,
        expires: 8, // 修复：使用 expires (天数)，替代 maxAge (秒)
        sameSite: 'None', // 修复：使用驼峰命名 sameSite
        secure: true, // 修复：SameSite: 'None' 必须配合 secure: true
      })
    })
  },
  LOGOUT(state) {
    const initState = getDefaultState()
    state.token = initState.token
    state.refreshToken = initState.refreshToken
    state.userInfo = initState.userInfo
    state.getUserInfoTimer = initState.getUserInfoTimer
    state.popupLoginStatus = initState.popupLoginStatus
    // console.log('logout总准备清空', cookieKeys)
    cookieKeys.forEach((key) => {
      cookie.remove(key, {
        path: cookiePath,
        domain,
      })
    })
  },
  update(state, payload) {
    Object.keys(payload).forEach((k) => {
      // console.log('update', state[k], payload[k]);
      if (isObject(payload[k])) {
        // console.log('state[k], payload[k], 是对象', state[k], payload[k], k)
        if (payload[k]) {
          state[k] = Object.assign(state[k], payload[k])
        }
      } else if (payload[k]) {
        state[k] = payload[k]
      }
    })
  },

  UPDATE_GET_USER_INFO_TIMER(state, timer) {
    state.getUserInfoTimer = timer
  },
  setShowBadgeDotKeys(state, data) {
    state.showBadgeDotKeys = data
  },
  // 更新展览待审核数量
  UPDATE_EXHIBITION_AUDIT_NUM: (state, num) => {
    const unReadNum = num < 0 ? 0 : num
    // console.log('UPDATE_EXHIBITION_AUDIT_NUM', unReadNum)
    state.auditingNum = unReadNum
  },
}
export const actions = {
  // vuex 服务端初始化
  async initializeApp({ commit, dispatch }) {
    // 获取 token（从 cookie 或 localStorage）
    const token = cookie.get('token')
    if (token) {
      commit('SET_TOKEN', token)
    }

    // 获取 host（客户端）
    if (process.client) {
      const host = window.location.host
      commit('updateHost', host)
      // locale 可从路由或配置获取
      commit('updateLocale', 'zh') // 或动态获取

      // 从 Cookie 或 URL 参数中获取供应链ID
      const urlParams = new URLSearchParams(window.location.search)
      const supplyUnicodeFromUrl = urlParams.get('toSupplyId')
      const supplyUnicodeFromCookie = cookie.get('supplyUnicode')
      const supplyUnicode = supplyUnicodeFromUrl || supplyUnicodeFromCookie

      console.log('initializeApp: supplyUnicodeFromUrl', supplyUnicodeFromUrl)
      console.log('initializeApp: supplyUnicodeFromCookie', supplyUnicodeFromCookie)
      console.log('initializeApp: supplyUnicode', supplyUnicode)

      if (supplyUnicode) {
        console.log('initializeApp: Setting supplyUnicode from', supplyUnicodeFromUrl ? 'URL' : 'Cookie', supplyUnicode)
        commit('updateSupplyUnicode', supplyUnicode)
        // 同步到 cookie，使用 domain 以便主站和供应链站点共享
        cookie.set('supplyUnicode', supplyUnicode, { path: '/', domain })
        // 获取供应链详情
        await dispatch('getSupplyInfo')
      }
    }
  },
  // 获取供应链信息
  async getSupplyInfo({ commit, state }) {
    console.log('获取供应链信息 getSupplyInfo ===')
    console.log('state.supplyUnicode', state.supplyUnicode)
    if (!state.supplyUnicode) {
      return
    }
    const { code, data } = await getSupplyInfoList(state.supplyUnicode)
    console.log('getSupplyInfoList', data)

    if (code === 0 && data) {
      const supplyChainInfo = {
        ...data,
        banners: data.banner
          ? data.banner.map((d) => {
              return {
                id: d.id,
                title: d.title,
                fileUrl: d.fileUrl,
                redirectUrl: d.redirectUrl,
              }
            })
          : [],
        logo: data.logo || data.enLogo,
      }

      if (state.locale === 'zh') {
        supplyChainInfo.title = data.title
      } else if (state.locale === 'en') {
        supplyChainInfo.title = data.enTitle
      }

      commit('updateSupplyChainInfo', { ...supplyChainInfo })
    }
  },
  async refreshShowBadgeDotKeys({ commit, state }) {
    // console.log('refreshShowBadgeDotKeys', state)
    const consolePath = 'account'
    const newShowBadgeDotKeys = []

    const { data } = await getRamNotReviewedNumberApplications()
    if (data && data.subMemberJoinUnOpsNum) {
      newShowBadgeDotKeys.push(`${consolePath}-ram`)
      newShowBadgeDotKeys.push(`${consolePath}-customerManagement`)
    }

    commit('setShowBadgeDotKeys', newShowBadgeDotKeys)
  },

  /**
   * 用户名账号登录
   * @param commit
   * @param {*} userInfo
   * @returns true,false
   */
  async loginByUsername({ commit }, userInfo) {
    try {
      console.log('loginByUsername start', userInfo)

      const { code, data, msg } = await login(userInfo)
      console.log('loginByUsername', code, data, msg)
      if (code === 0) {
        commit('SET_LOGIN_COOKIE', {
          token: data.access_token,
          refreshToken: data.refresh_token,
        })
        return ''
      }
      return msg
    } catch (err) {
      console.log('loginByUsernameError', err)
      return Promise.reject(err)
    }
  },
  async getUserInfo({ commit, state }) {
    try {
      const nowTime = Date.now()

      // console.log(
      //   'getUserInfoTimer',
      //   state.getUserInfoTimer,
      //   nowTime,
      //   state.getUserInfoTimer && nowTime - state.getUserInfoTimer < 5000,
      // );

      // 计算两个时间差是否超过5秒, 如果是, 更新时间
      if (state.getUserInfoTimer && nowTime - state.getUserInfoTimer < 5000 && state.userInfo.huanxinId) {
        // 有可能过一会才会更新用户信息,先隐藏不返回的

        // 如果用户信息已经存在, 直接返回, 如果不存在返回空对象
        // if (!state.userInfo.huanxinId) {
        //   return {};
        // }
        return {
          code: 0,
          data: state.userInfo || {},
        }
      }

      const token = cookie.get('token') || state.token
      console.log('getUserInfo', token)
      // 必须只有客户端才可以请求,否则信息是会共享到其他终端用户
      if (process.client && token) {
        commit('UPDATE_GET_USER_INFO_TIMER', nowTime)
        const res = await getUserDetail(token)
        if (res && res.code === 0) {
          // console.log('cookies-roleId', res.data.roleId)
          cookie.set('roleId', res.data.roleId, {
            domain,
            sameSite: 'Lax',
          })

          if (res.data) {
            // console.log('更新store', res.data)
            commit('SET_TOKEN', token)
            commit('update', { userInfo: res.data })
            return res
          }
        } else {
          return res
        }
      }
      return {}
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * 刷新token
   */
  async updateToken({ commit }, refreshToken) {
    try {
      // console.log('updateToken', refreshToken)
      if (refreshToken) {
        const res = await getUpdateToken(refreshToken)
        // console.log('updateToken-res', res)
        if (res.code !== 0) {
          return false
        }
        // 更新token
        commit('SET_LOGIN_COOKIE', {
          token: res.data.access_token,
          refreshToken: res.data.refresh_token,
        })
        return true
      }
      return false
    } catch (err) {
      return Promise.reject(err)
    }
  },
  /**
   * 退出登录
   * @returns true,false
   */
  async logout({ commit, state }) {
    try {
      if (state.token && process.client) {
        const { code } = await logout()
        // 暂时 处理code是1 也清除所有登录状态
        if (code === 0 || code === 1) {
          commit('chat/RESET_ALL')
          commit('LOGOUT')
          return true
        }
      }
      return false
    } catch (err) {
      return Promise.reject(err)
    }
  },
  // 根据token获取用户信息, 检测是否登录
  checkLoginStatus() {
    try {
      const token = cookie.get('token')
      if (token) {
        return true
      }
      return false
    } catch (error) {
      console.log(error)
    }
  },
  async getExhibitionAuditNum({ commit }) {
    const { data } = await getAuditingNum()
    if (data) {
      commit('UPDATE_EXHIBITION_AUDIT_NUM', data.audtingNum)
    }
  },
}

export const getters = {
  /**
   * 会员信息
   * @use 发布模型|
   */
  token(state) {
    return state.token
  },
  coinValidSum: (state) => state.userInfo.memberAccount.coinValidSum,
  vipStatus: (state) => state.userInfo.vipStatus,
  userName: (state) => state.userInfo.username,
  phone: (state) => state.userInfo.phone,
  email: (state) => state.userInfo.email,
  roleId: (state) => state.userInfo.roleId,
  avatar: (state) => state.userInfo.avatar,
  memunicode: (state) => state.userInfo.memunicode,
  // 账户级别 0-普通,1-主账户,2-子账户
  accountLevel: (state) => state.userInfo.accountLevel,
  // 身份 0-企业,1-个人
  companyFlag: (state) => state.userInfo.companyFlag,
  inviteCode: (state) => state.userInfo.inviteCode,
  wxOpenid: (state) => state.userInfo.wxOpenid,
  /**
   * 会员信息
   * @use 发布模型|
   */
  userInfo(state) {
    return state.userInfo
  },
  /**
   * 返回当前角色身份的控制台路径
   * @use 发布模型|
   */
  getConsolePath(state) {
    // 统一使用 /account 前缀
    return '/account'
  },
  companyIndustryName: (state) => state.userInfo.companyIndustryName,
  interestedIndustryName: (state) => state.userInfo.interestedIndustryName,
  certModalType: (state) => state.certModalType,
  /**
   * 判断是否是个人版
   * 如果 setMealCode 小于 60000，则是个人版
   * @returns {Boolean} true-个人版, false-非个人版
   */
  isPersonalVersion(state) {
    const setMealCode = state.userInfo.memberSetMealInfo?.setMealCode || 0
    // 110000是未认证
    return setMealCode === 110000
  },
}
